import { render, staticRenderFns } from "./CentralInsert.vue?vue&type=template&id=66181636&"
import script from "./CentralInsert.vue?vue&type=script&lang=ts&"
export * from "./CentralInsert.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/components/miscellaneous/central-insert.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports